'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _base = require('../../Base/collections/base.cll');

var _base2 = _interopRequireDefault(_base);

var _db = require('../db.json');

var _db2 = _interopRequireDefault(_db);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _userAgent = require('../../../common/userAgent.0.0.3');

var _userAgent2 = _interopRequireDefault(_userAgent);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formatter = require('../../Base/utils/formatter.u');

var _formatter2 = _interopRequireDefault(_formatter);

var _IPhone = require('../../../common/iObjects/IPhone');

var _IPhone2 = _interopRequireDefault(_IPhone);

var _escapeRegExp = require('../../Base/utils/escapeRegExp.u');

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var collection = new _base2.default(_db2.default),
    _threeDigitsCode = collection.filter(function (item) {
    return item.get('dialCode') && item.get('dialCode').length === 4;
}),
    _twoDigitsCode = collection.filter(function (item) {
    return item.get('dialCode') && item.get('dialCode').length === 3;
}),
    _oneDigitsCode = collection.filter(function (item) {
    return item.get('dialCode') && item.get('dialCode').length === 2;
});

// for event emulation
var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this.collection = collection;

        _this.state = {
            focus: false,
            hover: false
        };

        _this.state = Object.assign({}, _this.state, _this._parseValue(props.value));

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(this);
            }

            return this;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                this.setState(Object.assign({}, this._parseValue(nextProps.value)));
            }

            return this;
        }
    }, {
        key: '_dispatchSyntheticEvent',
        value: function _dispatchSyntheticEvent() {
            var event = {
                target: this,
                currentTarget: this,
                preventDefault: preventDefault,
                stopPropagation: stopPropagation,
                type: 'change'
            };

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event);
            }
        }
    }, {
        key: '_handleChangeCode',
        value: function _handleChangeCode(event) {
            var _this2 = this;

            this.setState({ code: event.target.value }).then(function () {
                _this2._dispatchSyntheticEvent();

                _this2.focus();
            });

            return this;
        }
    }, {
        key: '_handleChangeNumber',
        value: function _handleChangeNumber() {
            var _this3 = this;

            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var value = void 0;

            if (event.nativeEvent && event.nativeEvent.inputType === 'insertFromPaste') {
                this.value = event.target.value;
            } else {
                value = event.target.value.replace(/[^0-9]+/ig, '');
                this.setState({ number: value }).then(function () {
                    _this3._dispatchSyntheticEvent();
                });
            }

            return this;
        }
    }, {
        key: '_numberFormat',
        value: function _numberFormat() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            // В Android-браузере проблемы со сменой клавиатуры при вводе форматированного текста
            if (!_userAgent2.default.os.isAndroid) {
                if (this.state.code === 'UA+380') {
                    value = (0, _formatter2.default)(value, '{{dd}} {{ddd}} {{dd}} {{dd}}');
                } else if (this.state.code === 'RU+7') {
                    value = (0, _formatter2.default)(value, '{{ddd}} {{ddd}} {{ddd}} {{ddd}}');
                } else {
                    value = (0, _formatter2.default)(value, '{{ddd}} {{ddd}} {{ddd}} {{ddd}}');
                }
            }

            return value;
        }
    }, {
        key: '_handleFocus',
        value: function _handleFocus() {
            var _this4 = this;

            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.setState({ focus: true }).then(function () {
                if (typeof _this4.props.onFocus === 'function') {
                    _this4.props.onFocus(event);
                }
            });

            return this;
        }
    }, {
        key: '_handleBlur',
        value: function _handleBlur() {
            var _this5 = this;

            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.setState({ focus: false }).then(function () {
                if (typeof _this5.props.onBlur === 'function') {
                    _this5.props.onBlur(event);
                }
            });

            return this;
        }
    }, {
        key: '_handlePaste',
        value: function _handlePaste() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            event.preventDefault();
            var text = event.clipboardData.getData('text/plain').trim();

            this.value = this._parseValue(text);

            return this;
        }
    }, {
        key: '_parseValue',
        value: function _parseValue() {
            var _this6 = this;

            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var country = void 0,
                number = '';

            if (value instanceof _IPhone2.default) {
                value = value.toString();
            }

            if (value && value[0] === '+') {
                var phoneCode = value.substr(0, 4);
                country = _threeDigitsCode.filter(function (item) {
                    return item.get('dialCode') === phoneCode;
                });

                if (!country.length) {
                    phoneCode = value.substr(0, 3);
                    country = _twoDigitsCode.filter(function (item) {
                        return item.get('dialCode') === phoneCode;
                    });
                }

                if (!country.length) {
                    phoneCode = value.substr(0, 2);
                    country = _oneDigitsCode.filter(function (item) {
                        return item.get('dialCode') === phoneCode;
                    });
                }

                if (!country.length) {
                    country = [this.collection.get('UA+380')];
                }

                // один телефонный код может соответствовать разным странам
                // если в селекте уже выбран код одной из таких стран, не нужно его перетирать
                if (country.length && country.length > 1 && this.state.code) {
                    var match = country.filter(function (item) {
                        return item.id === _this6.state.code;
                    });

                    country = match && match.length ? match[0] : country[0];
                } else {
                    country = country[0];
                }

                number = value.replace(country.get('dialCode'), '');
            } else {
                country = this.collection.get('UA+380');
                number = value;
            }

            return {
                code: country.id,
                number: number
            };
        }
    }, {
        key: '_codeSearchFunc',
        value: function _codeSearchFunc() {
            var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var result = void 0;
            query = new RegExp((0, _escapeRegExp2.default)(query), 'i');

            result = this.collection.filter(function (model) {
                return query.test(model.get('dialCode')) || query.test(model.get('name').ua) || query.test(model.get('name').ru) || query.test(model.get('name').en);
            });

            result = new _base2.default(result);

            return list.filter(function (item) {
                return !!result.get(item.id);
            });
        }
    }, {
        key: '_inputRef',
        value: function _inputRef(el) {
            this.input = el;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.disabled) + String(this.props.error) + String(this.state.hover) + String(this.state.focus);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.input.focus();

            if (this.state.number && this.state.number.length) {
                try {
                    this.input.selectionStart = this.state.number.length;
                } catch (e) {}
            }
        }
    }, {
        key: 'node',
        value: function node() {
            return this.input;
        }
    }, {
        key: '_handleHover',
        value: function _handleHover() {
            return this.setState({ hover: true });
        }
    }, {
        key: '_handleRootBlur',
        value: function _handleRootBlur() {
            return this.setState({ hover: false });
        }
    }, {
        key: 'value',
        get: function get() {
            var country = this.collection.get(this.state.code);
            return (country && country.get('dialCode') || '') + (this.state.number || '');
        },
        set: function set(value) {
            var _this7 = this;

            this.setState(Object.assign({}, this._parseValue(value))).then(function () {
                return _this7._dispatchSyntheticEvent();
            });
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    label: '',
    lang: 'ua'
};
Main.propTypes = {
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    elementRef: _propTypes2.default.func
};
Main.displayName = 'Phone';
exports.default = Main;